var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.label.length || _vm.bundleType === "bundle",
          expression: "label.length || bundleType === 'bundle'"
        }
      ],
      staticClass: "special-tags"
    },
    [
      _vm.label.length && _vm.tagClass == "badge-offer badge-danger"
        ? _c("img", {
            attrs: {
              width: "50",
              height: "50",
              loading: "lazy",
              src: _vm.pluginPath + "/images/svg/sale-icon.svg"
            }
          })
        : _vm.label.length && _vm.tagClass == "badge-new badge-primary"
        ? _c("img", {
            attrs: {
              width: "50",
              height: "50",
              loading: "lazy",
              src: _vm.pluginPath + "/images/svg/neu-icon.svg"
            }
          })
        : _vm.label.length && _vm.tagClass == "badge-top badge-success"
        ? _c("img", {
            attrs: {
              width: "50",
              height: "50",
              loading: "lazy",
              src: _vm.pluginPath + "/images/svg/top-icon.svg"
            }
          })
        : _c("span", { staticClass: "badge badge-bundle bg-info" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$translate("Ceres::Template.itemBundle")) +
                "\n    "
            )
          ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }